export const CONFIRM_PROSPECT = 'App/Middleware::CONFIRM_PROSPECT';
export const CONFIRM_MEMBER = 'App/Middleware::CONFIRM_MEMBER';
